import useAppSelector from "hooks/useAppSelector";
import { FC, ImgHTMLAttributes } from "react";

interface AppImageProps extends ImgHTMLAttributes<HTMLImageElement> { }

const AppImage: FC<AppImageProps> = (props) => {
    const { logoUrl } = useAppSelector(state => state.config);
    return <img
        {...props}
        src={props.src || `/view/images/no-image.png`}
        onError={(e) => {
            const size = `${e.currentTarget.clientWidth} x ${e.currentTarget.clientHeight}`
            e.currentTarget.title = size;
            e.currentTarget.src = `/view/images/no-image.png`;
        }}
    />;
};
export default AppImage;